<template>
	<!-- Merge with Library Card System -->

	<div 
		class="card-abstract" 
		:class="{ 
			'fullscreen': isFullscreen,
			'active': isActive
		}">
		<slot></slot>
	</div>
</template>

<script>
import { mapGetters } from '@generio-ai/library-legacy/plugins/vuex'

export default {
	name: 'CardAbstract',
	props: {
		app: {
            type: String,
            required: true
        },
		card: {
			type: Object,
			required: true
		},
	},
	data() {
		return {
			mounted: false
		}
	},
	computed: {
		...mapGetters('flows', [
			'isActiveByIndex',
			'isFullscreen'
		]),

		isActive() {
			return this.mounted && this.isActiveCard
		},
		isActiveCard() {
			return this.isActiveByIndex(this.app, this.index)
		},

		index() {
			return this.card.index
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.mounted = true
		})
	}
}
</script>

<style scoped>
.card-abstract {
	--card-height: 80vh;
	flex-shrink: 0;
	height: var(--card-height);
	width: 100%;
	max-width: max(1800px, calc(var(--card-height) * 1.6));
	box-sizing: border-box;
	background: linear-gradient(
		rgba(var(--v-theme-darkerbase), 0.3) 0%,
		rgba(var(--v-theme-darkerbase), 0.5) 50%,
		rgba(var(--v-theme-darkerbase), 0.3) 100%
	);
	border-radius: 8px;
	border: 1px solid rgb(var(--v-theme-lightbase));
	scroll-snap-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.4rem;
	overflow: hidden;
	opacity: 0.9;
	transition: opacity 0.3s ease, box-shadow 0.3s ease;
}

.card-abstract.fullscreen {
	--card-height: 100vh;
	max-width: unset;
	border-radius: 0;
	box-shadow: none;
}

.card-abstract.active {
	opacity: 1;
	box-shadow: 0px 0px 15px rgba(var(--v-theme-color1), 0.2);
}

@media (max-width: 800px) {
	.card-abstract.fullscreen {
		--card-height: 85vh;
	}

	.card-abstract {
		--card-height: 85vh;
		margin-bottom: 15vh;
		border-radius: 0;
	}
}

@media (max-width: 600px) {
	.card-abstract.fullscreen {
		--card-height: 75vh;
	}

	.card-abstract {
		--card-height: 75vh;
		margin-bottom: 25vh;
		border-radius: 0;
	}
}
</style>
